export default {"src":"/_next/static/media/pic_02.a9602a91.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};